// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","746":"component---src-templates-prime-xbt-shared-tsx"}[chunkId] + "-" + {"532":"2dbf7ee51261abcf9d08","746":"e323f659ecbb7066d530"}[chunkId] + ".js";
};